module.exports = __webpack_public_path__ + "static/langojango-vietnamese-language-phrasebook-108ff7d2503ae1dfee9c64b933088c33.png";